function replaceStr(value) {
  return value.replace(/\D+/g, '');
}

export default {
  bind(el) {
    el.handler = function() {
      if (el.children.length) {
        el.children.forEach(item => {
          item.value = replaceStr(item.value);
        });
      } else {
        el.value = replaceStr(el.value);
      }
    };
    el.addEventListener('input', el.handler);
  },
  unbind(el) {
    el.removeEventListener('input', el.handler);
  }
};